import React from 'react';

const TableImage = ({ imageUrl, altText }) => {

    return (
        <img src={imageUrl} alt={`${altText}-profile-pic`} className='h-8 aspect-square rounded-full object-contain mx-auto' onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = process.env.PUBLIC_URL + "";
        }} />
    )
}

export default TableImage